import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';

import SlickBar from 'components/SlickBar';
import ImageThumbnail from '../elements/ImageThumbnail';
// import ImageModal from 'components/ImageModal';

// import vw from 'styles/utils';

import { getFeatureNews } from 'utils/request';
import hero from 'data/hero';
// import imageData from 'data/image';

function News() {
  // const [isShowModal, setIsShowModal] = useState(false);
  // const [imageSrc, setImageSrc] = useState(null);
  // const [imageUrl, setImageUrl] = useState(null);
  const [newsArticle, setNewsArticle] = useState('empty');
  const [imagesIndex, setImagesIndex] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const featureNews = await getFeatureNews();
      // const newsArticle = await getFeatureNews();

      // setFeatureNews(featureNews)
      await setNewsArticle(featureNews)
      // console.log("featureNews = ", featureNews)
    }
    fetchData();
  }, [])

  useEffect(() => {
    let tmpImagesIndex = [];
    let indexPool = Array.from(Array(16).keys()); // [0, 1, 2 ... 14, 15]

    for (let i = 0; i < 14; i++) {
      let index = Math.floor((Math.random() * indexPool.length));
      tmpImagesIndex.push(indexPool[index]);
      indexPool.splice(index, 1);
      // console.log(index, tmpImagesIndex)
    }

    setImagesIndex(tmpImagesIndex)
  }, [])

  // const handleClickCloseButton = () => {
  //   setIsShowModal(false);
  // }

  // const handleShowModal = (index) => {
  //   setImageSrc(imageData[index].src);
  //   setImageUrl(imageData[index].url)
  //   setIsShowModal(true);
  // }

  return (
    <>
      {
        newsArticle !== 'empty' && newsArticle?.ArticleList &&
        <Root>
          <SlickBar
            icon={require('assets/images/icons/mountain.png')}
            title="精選新聞"
            slidesToShow={4}
            slidesToScroll={4}
            moreUrl="https://ieknet.iek.org.tw/ieknews/default.aspx?actiontype=ieknews&indu_idno=12"
          >
            {
              newsArticle?.ArticleList.map((article, index) => (
                <ImageThumbnail
                  title={article.title}
                  time={article.date}
                  src={hero[imagesIndex[index]]}
                  url={article.url}
                  key={article.title}
                />
              ))
            }
          </SlickBar>
          {/* <ImageModal
            show={isShowModal}
            srcUrl={imageSrc}
            url={imageUrl}
            onClickCloseButton={handleClickCloseButton}
          /> */}
        </Root>
      }
    </>
  )
}

const Root = styled.section`
`;

export default News
